var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2634_16587",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 12,
    width: 18,
    height: 19
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.668 12.8335H30.7511V30.7543H13.668V12.8335Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2634_16587)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4321 24.7427C24.4355 24.7427 25.2521 25.5536 25.2521 26.5502V29.1136C25.2521 29.3277 25.4238 29.4994 25.6438 29.5044H27.2321C28.4838 29.5044 29.5013 28.4994 29.5013 27.2644V19.9944C29.4955 19.5694 29.293 19.1694 28.9455 18.9036L23.4513 14.5219C22.7138 13.9377 21.6821 13.9377 20.9421 14.5236L15.4855 18.9019C15.1246 19.1761 14.9221 19.5761 14.918 20.0086V27.2644C14.918 28.4994 15.9355 29.5044 17.1871 29.5044H18.7905C19.0163 29.5044 19.1996 29.3252 19.1996 29.1052C19.1996 29.0569 19.2055 29.0086 19.2155 28.9627V26.5502C19.2155 25.5594 20.0271 24.7494 21.023 24.7427H23.4321ZM27.2321 30.7544H25.6288C24.7105 30.7327 24.0021 30.0119 24.0021 29.1136V26.5503C24.0021 26.2428 23.7463 25.9928 23.4321 25.9928H21.0271C20.7196 25.9944 20.4655 26.2453 20.4655 26.5503V29.1053C20.4655 29.1678 20.4571 29.2278 20.4396 29.2844C20.3496 30.1094 19.6446 30.7544 18.7905 30.7544H17.1871C15.2463 30.7544 13.668 29.1886 13.668 27.2644V20.0027C13.6763 19.1744 14.058 18.4161 14.7171 17.9169L20.163 13.5461C21.3621 12.5961 23.033 12.5961 24.2296 13.5444L29.7146 17.9194C30.3588 18.4102 30.7405 19.1669 30.7513 19.9852V27.2644C30.7513 29.1886 29.173 30.7544 27.2321 30.7544Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.262060ad.svg";
export { ForwardRef as ReactComponent };